"use client";

import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
const partners = [{
  id: 1,
  name: "Emory Healthcare",
  role: "Primary Medical Network",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/logo_emory_health.png"
}, {
  id: 2,
  name: "Northside Hospital",
  role: "Specialized Care Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/logo_northside_hospital.png"
}, {
  id: 3,
  name: "Piedmont Atlanta",
  role: "Cardiology & Wellness Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/logo_piedmont_atlanta.png"
}, {
  id: 4,
  name: "Grady Health System",
  role: "Public Health Affiliate",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/logo_grady_health.png"
}, {
  id: 5,
  name: "Wellstar Health",
  role: "Regional Care Network",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/logo_wellstar_atlanta.png"
}, {
  id: 6,
  name: "Children's Healthcare of Atlanta",
  role: "Pediatric Care Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/logo_choa_medical.png"
}, {
  id: 7,
  name: "Atlanta Medical Center",
  role: "Emergency Services Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/logo_atlanta_medical.png"
}, {
  id: 8,
  name: "Resurgens Orthopaedics",
  role: "Surgical Specialty Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/logo_resurgens_ortho.png"
}];
export default function OurTrustedPartners() {
  const marqueeItems = [...partners, ...partners];
  return <section data-section-id="224102" id="doctor-backed-reliability" className="bg-accent/30 py-16 md:py-24 overflow-hidden border-y border-border/40">
      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee-scroll {
          animation: marquee-scroll 40s linear infinite;
        }
      `}</style>

      <div className="container mx-auto px-4 md:px-6 mb-10">
        <h2 className="text-center text-sm md:text-base font-default font-bold tracking-widest uppercase text-primary">
          Trusted by Atlanta's Leading Physicians
        </h2>
      </div>

      <div className="relative flex overflow-hidden group w-full">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 md:w-32 bg-gradient-to-r from-accent/30 to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 md:w-32 bg-gradient-to-l from-accent/30 to-transparent" />

        <div className="flex w-max animate-marquee-scroll group-hover:[animation-play-state:paused] items-center gap-12 md:gap-24 px-6 md:px-12">
          {marqueeItems.map((partner, i) => <div data-index={i} key={`${partner.id}-${i}`} className="flex-shrink-0 flex flex-col items-center">
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="flex flex-col items-center justify-center cursor-help transition-transform duration-500 hover:scale-105">
                    <div className="flex items-center justify-center h-16 w-32 md:w-48">
                      <img src={partner.logo} alt={`${partner.name} logo`} className="max-h-10 md:max-h-14 w-auto object-contain grayscale opacity-40 transition-all duration-700 ease-in-out hover:grayscale-0 hover:opacity-100" loading="lazy" />
                    </div>
                    <p className="mt-2 text-[10px] md:text-xs font-mono font-medium uppercase tracking-widest text-muted-foreground/60 text-center">
                      {partner.name}
                    </p>
                  </div>
                </TooltipTrigger>
                <TooltipContent side="bottom" className="font-default bg-card border-border shadow-lg">
                  <p className="font-bold text-sm text-foreground">{partner.name}</p>
                  <p className="text-xs text-muted-foreground">
                    {partner.role}
                  </p>
                </TooltipContent>
              </Tooltip>
            </div>)}
        </div>
      </div>
    </section>;
}